export default "__VITE_ASSET__a1881909__"